import View from "./View";

class PaginationView extends View {
    _parentElement = document.querySelector(".pagination ul");
    _generateMarkup() {
        const currentPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.historyPerPage);
        let markUp = "";
        for (let i = 0; i < numPages; i++) {
            markUp += `<li data-page=${i + 1} class="pagination__item ${currentPage === i + 1 ? "current" : ""}" aria-label="Goto Page ${i + 1}"
            aria-current="${currentPage === i + 1 ? true : false}"
            >${i + 1}</li>`
        }

        return markUp;
    }
    clickPaginationItem(handler) {
        this._parentElement.addEventListener("click", e => {
            const button = e.target.closest(".pagination__item");
            if (!button) return;
            const id = button.dataset.page;
            handler(id)
        })
    }

}

export default new PaginationView();